import * as T from './types';
import v1Auth from './v1/auth';
import v2Auth from './v2/auth';
import { initializeCommons } from '../infra/startup';
import { CommonsInitializeType } from '../infra/startup/types';
import { APIsFactory } from '../infra/startup/interfaceFactory';
import { ClientOSInterfacesType } from '@clientos/types/dist';
import { ClientOSError } from '../infra/errors/ClientOSError';
import { ClientOSErrorCodes } from '../infra/errors/ErrorCodes';

/**
 * Validates initialization state
 * Single Responsibility: Handles state validation logic
 */
function shouldInitialize(shell: T.ShellStatesType): boolean {
  return !shell.initialized || !shell.loading;
}

const interfaces = {
  /** This property is only used internally, do not use this */
  _shell: {
    initialized: false,
    loading: false,
    error: false,
    initializers: {
      authProvider: {
        v1: v1Auth,
        v2: v2Auth
      }
    },
    init: async (initializerState: T.InterfacesInitializerStatePropsType) => {
      // Guard clause: prevent unnecessary re-initialization
      if (!shouldInitialize(interfaces._shell)) {
        return;
      }

      try {
        // Initialize commons
        const commonsProps: CommonsInitializeType = await initializeCommons(
          initializerState?.manifest as any,
          initializerState?.options as any
        );

        const { onboarding: onboardingInput } = commonsProps;
        // TODO: do a better solution to inject this dependencies
        APIsFactory.ConfigureWebServiceRouting(onboardingInput);
        // Set initialization state
        interfaces._shell.initialized = true;
        interfaces._shell.loading = true;
        interfaces._shell.error = false;

        // Initialize interface versions
        const { v1, v2 } = await APIsFactory.createAPIs(commonsProps);

        interfaces.v1 = v1;
        interfaces.v2 = v2;
        interfaces._shell.loading = false;
      } catch (error) {
        // E.1: Interface initialization failure — set error state and surface structured code.
        interfaces._shell.loading = false;
        interfaces._shell.error = true;
        if (error instanceof ClientOSError) throw error;
        throw new ClientOSError(
          'Interface initialization failed',
          ClientOSErrorCodes.SERVICE_FAILED,
          error
        );
      }
    }
  }
} as ClientOSInterfacesType;

export default interfaces;
